import { render } from "./Admin.Settings.vue?vue&type=template&id=593a208d"
import script from "./Admin.Settings.vue?vue&type=script&lang=js"
export * from "./Admin.Settings.vue?vue&type=script&lang=js"

import "./Admin.Settings.vue?vue&type=style&index=0&id=593a208d&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__